import { render, staticRenderFns } from "./RequestDialog.vue?vue&type=template&id=545c406d&scoped=true"
import script from "./RequestDialog.vue?vue&type=script&lang=ts"
export * from "./RequestDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545c406d",
  null
  
)

export default component.exports